import React from 'react'
import { PublicLayoutHeader } from '../PublicLayout/Header'

import ForgotPasswordForm from './ForgotPasswordForm'

const ForgotPasswordPage = () => {
    return (
        <>
            <PublicLayoutHeader
                title="Reset Password"
                subtitle="We'll get you up and running again in no time."
            />
            <ForgotPasswordForm />
        </>
    )
}

export default ForgotPasswordPage
